import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVisit } from '../api/visits';
import { Visit } from '../types/visit';
import { useToast } from '../../../hooks/use-toast';

export function useScheduleReminder() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ visitId, reminders }: { 
      visitId: string;
      reminders: {
        id: string;
        date: string;
        notes?: string;
        isUrgent?: boolean;
      }[];
    }) => {
      const visit = await updateVisit({
        id: visitId,
        physicianReminders: reminders
      } as Visit);
      return visit;
    },
    onSuccess: (_, { reminders }) => {
      queryClient.invalidateQueries({ queryKey: ['visits'] });
      toast({
        title: "Reminders scheduled",
        description: `${reminders.length} physician reminder${reminders.length === 1 ? '' : 's'} scheduled successfully.`,
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: "Failed to schedule reminders. Please try again.",
        variant: "destructive",
      });
      console.error('Failed to schedule reminder:', error);
    },
  });
}
